<template>
    <h1 class="text-primary">Ligipääsetavuse avaldus</h1>
    <br>
    <p>
        Alljärgnevalt kirjeldame vastavust ligipääsetavusnõuetele.
    </p>
    <br>
    <p>
        Euroopa Liidus kehtib digiteenuste osutamisel ligipääsetavuse nõue, mis eeldab, et kõik avalikud teenused peavad olema ligipääsetavad. See tähendab et, see vastaks avaliku <a class="text-primary" :href="ligipaasetavuseNoudeSeadusUrl">teabe seaduse § 32</a> alusel kehtestatud ligipääsetavusnõuetega (need on kehtestatud standardiga <a class="text-primary" :href="ligipaasetavusStandardUrl">{{ ligipaasetavusStandardVersion }}</a>).
    </p>
    <br>
    <p>
        Käesolev avaldus kehtib Justiits- ja Digiministeeriumi hallatavale veebilehe <a class="text-primary" :href="domeeniUrl">{{ domeeniUrl }}</a> kohta, mis peab olema ligipääsetav Avaliku teabe seaduse §32 alusel.
    </p>
    <br>
    <br>
    <p><b>Töötame pidevalt ligipääsetavuse parandamiseks</b></p>
    <p>
        Praegu on käimas veebilehe ligipääsetavuse hindamine, mille tulemused avaldame niipea, kui analüüs on lõpule viidud.
    </p>
    <br>
    <br>
    <p><b>Tagasiside</b></p>
    <p>
        Andke ligipääsetavuse kohta tagasisidet kirjutades kasutajatoele.
    </p>
    <p>
        E-post: {{ kasutajatugiEmail }}
    </p>
    <p>
        Vastame teile tavaliselt {{ kasutajatugiResponseTimeInDays }} tööpäeva jooksul.
    </p>
    <br>
    <br>
    <p><b>Ligipääsetavuse järelevalve asutus</b></p>
    <p>
        Avalike teenuste veebide ja rakenduste ligipääsetavuse osas teostab järelevalvet {{ jarelvalveName }}.
    </p>
    <p>
        Veebileht: {{ jarelvalveWebsite }}
    </p>
    <p>
        E-post: {{ jarelvalveEmail }}
    </p>
    <p>
        Telefon: {{ jarelvalvePhone }}
    </p>
    <br>
    <br>
    <p>
        Käesolev avaldus on koostatud {{ avalduseKoostamiseKp }}
    </p>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import moment from 'moment';

export default defineComponent({
    name: 'LigipaasetavusTekst',
    setup() {
        const avalduseKoostamiseKp = moment().format('DD.MM.YYYY');

        const domeeniUrl = window.location.origin;
        const kasutajatugiEmail = 'vangla.haldus@rik.ee';
        const kasutajatugiResponseTimeInDays = 5;
        const jarelvalveName = 'Tarbijakaitse ja Tehnilise Järelevalve Amet';
        const jarelvalveWebsite = 'www.ttja.ee';
        const jarelvalveEmail = 'info@ttja.ee';
        const jarelvalvePhone = '667 2000';
        const ligipaasetavuseNoudeSeadusUrl = 'https://www.riigiteataja.ee/akt/AvTS#para32';
        const ligipaasetavusStandardUrl = 'https://www.etsi.org/deliver/etsi_en/301500_301599/301549/03.02.01_60/en_301549v030201p.pdf';
        const ligipaasetavusStandardVersion = 'EN 301 549 V.3.2.1';

        return {
            avalduseKoostamiseKp,
            domeeniUrl,
            kasutajatugiEmail,
            kasutajatugiResponseTimeInDays,
            jarelvalveName,
            jarelvalveWebsite,
            jarelvalveEmail,
            jarelvalvePhone,
            ligipaasetavuseNoudeSeadusUrl,
            ligipaasetavusStandardUrl,
            ligipaasetavusStandardVersion
        };
    },
})
</script>


<style scoped>

</style>